<template>
  <default-layout>
    <div v-if="getCourseLoading" key="loading" class="text-center mt-10">
      <p class="mb-2.5">Loading Roundtables</p>
      <div class="flex justify-center">
        <pl-spinner />
      </div>
    </div>
    <div v-else>
      <roundtables-course-table
        :roundtables="roundtables"
        @selectedRoundtable="viewActivity"
      />
    </div>

    <FullScreenChooseActivity
      v-if="show_choose_activity_overlay"
      @close="show_choose_activity_overlay = false"
      :courseID="getCourseDetail.id"
    />
    <!-- <roundTable-welcome-modal
      activityType="live"
      @close="closeRTWelcomeModal"
      v-if="show_RT_Welcome_modal"
      :data="welcomeRoundTableData"
    /> -->

    <integrations-connect-modal
      @close="show_sync_assessment_modal = false"
      v-if="integrations_modal === 1"
      :logo="logo"
      :edLink="edLink"
      :selectedIntegration="selected_integration"
    />
    <sync-assessment-data-modal
      v-if="integrations_modal === 3 && sync_assessment"
      @close="show_sync_assessment_modal = false"
      :activityType="activityType"
      :edLink="edLink"
      :selectedIntegration="selected_integration"
      :logo="logo"
    />
    <connect-integrations-assessment-modal
      v-if="show_integrations_modal"
      @close="show_integrations_modal = false"
    />
    <integrations-assignment-modal
      v-if="
        integrations_modal === 2 ||
        (integrations_modal === 3 && !sync_assessment)
      "
      @close="show_sync_assessment_modal = false"
      :logo="logo"
      :edLink="edLink"
      :selectedIntegration="selected_integration"
      :activityType="activityType"
    />
  </default-layout>
</template>

<script>
  // SERVICES
  import FullScreenChooseActivity from './components/fullScreenChooseActivity';

  import { mapGetters } from 'vuex';
  import store from 'store';
  import { EventBus } from 'utils/event-bus';
  import getWelcomeSettings from 'services/account/getWelcomeSettings';

  // COMPONENTS
  import defaultLayout from 'layouts/default/default.vue';
  import roundtablesCourseTable from './components/roundtablesCourseTable.vue';
  import Onboarding from 'features/onboarding/onboardingSteps';
  import courseSocketMixin from 'mixins/sockets/courseSocketEvents';
  //import RoundTableWelcomeModal from 'components/modals/roundTableWelcomeModal';
  import courseService from 'services/courses';
  import integrationsConnectModal from 'components/modals/integrationsConnectModal';
  import syncAssessmentDataModal from 'components/modals/syncAssessmentDataModal';
  import rtGoogleClassroomModal from 'components/modals/rtGoogleClassroomModal';
  import integrationsAssignmentModal from 'components/modals/integrationsAssignmentModal';
  import connectIntegrationsAssessmentModal from 'components/modals/connectIntegrationsAssessmentModal';

  export default {
    data() {
      return {
        last_roundtable_route: {
          name: null,
          params: null,
          quert: null,
        },
        show_RT_Welcome_modal:false,
        show_choose_activity_overlay: false,
        welcomeRoundTableData: null,
        show_sync_assessment_modal:false,
        show_integrations_modal:false,
        selected_integration: null,
        sync_assessment: false,
        edLink:null,
        logo:null,
      };
    },
    components: {
      defaultLayout,
      roundtablesCourseTable,
      //RoundTableWelcomeModal,
      Onboarding,
      FullScreenChooseActivity,
      integrationsConnectModal,
      connectIntegrationsAssessmentModal,
      syncAssessmentDataModal,
      rtGoogleClassroomModal,
      integrationsAssignmentModal,
    },
    mixins: [
      courseSocketMixin,
    ],
    watch: {
      isProfileLoading(is_loading, was_loading) {
        // Only load page when the profile is no longer loading
        if (was_loading && !is_loading) {
          this.loadPage();
        }
      },
    },
    computed: {
      ...mapGetters([
        'getCourseDetail',
        'getCourseLoading',
        'getProfile',
        'isProfileLoading',
        'getCurrentRT',
        'getCurrentDiscussion',
        'getOrderedOnlineRTs',
        'getOrderedLiveDiscussions',
        'hasTeacherPermissionsInCourse',
        'getCourseSequences',
      ]),
      route_default() {
        return {
          name: 'course.tab',
          params: {
            courseID: this.getCourseDetail.id,
            courseTab: 'roundtables',
          },
          query: null,
        };
      },
      activityType(){
         if (this.$route.params.roundtableID){
          return 'written';
        }
        if (this.$route.params.liveDiscussionID){
          return 'verbal';
        }
        return null;
      },
      currentActivity(){
        if (this.activityType === 'written'){
          return this.getCurrentRT;
        }
        return this.getCurrentDiscussion;
      },
      courseWorkId(){
        if (this.$route.params.roundtableID){
          return this.getCurrentRT.google_classroom_course_work_id;
        }
        if (this.$route.params.liveDiscussionID){
          return this.getCurrentDiscussion.google_classroom_course_work_id;
        }
        return null;
      },
      integrations_modal(){
        if (this.selected_integration !== 'google-classroom') return this.integration_connected;
        if (this.show_sync_assessment_modal){
          if(this.courseWorkId) return 3;
          if (this.getCourseDetail.google_classroom_integration.course_id) return 2;
          return 1;
        }
        return 0;
      },
      integration_connected(){
        if (this.show_sync_assessment_modal){
            if (this.currentActivity.edlink_integrations.map(ed => ed.provider_name.toLowerCase()).includes(this.selected_integration)){
              return 3;
            }
            if (this.getCourseDetail.edlink_integrations.map(ed => ed.provider_name.toLowerCase()).includes(this.selected_integration)){
              return 2;
            }
          return 1;
        }
        return 0;
      },
      current_rt_is_already_in_state() {
        return this.getCurrentRT.id &&
          this.$route.params.roundtableID &&
          this.getCourseDetail.id === this.getCurrentRT.course_id;
      },
      roundtablesTeachers() {
        return [...this.getOrderedOnlineRTs, ...this.getOrderedLiveDiscussions, ...this.getCourseSequences, ...this.getCourseDetail.drafts];
      },
      roundtablesStudents() {
        return [...this.getOrderedOnlineRTs, ...this.getOrderedLiveDiscussions, ...this.getCourseSequences];
      },
      roundtables() {
        const user = this.getCourseDetail.users.find((u) => u.id === this.getProfile.id);
        const userSubscription = user.subscription.role;

        if (userSubscription === 'student' || this.getProfile.role === 'student') {
          return this.roundtablesStudents;
        }
        return this.roundtablesTeachers;
      }
    },
    methods: {
      goToCourse(courseInfo, queryObject) {
        const { courseID } = courseInfo;
        let courseRoute = {};
        if (this.getCourseDetail.id !== courseID){
          courseService.courseDetails(courseID).then((res) => {
            if (res.roundtables && !res.roundtables.length
              && res.live_discussions && res.live_discussions.length
            ) {
              const liveDiscussionID = res.live_discussions[res.live_discussions.length - 1].id;

              courseRoute = {
                name: 'live-discussion.index',
                params: { courseID, liveDiscussionID },
                query: queryObject,
              };
            } else if (res.roundtables && res.roundtables.length) {
              const roundtableID = res.roundtables[res.roundtables.length - 1].id;

              courseRoute = {
                name: 'roundtable.feed',
                params: { courseID, roundtableID },
                query: queryObject,
              };
            } else {
              courseRoute = {
                name: 'course.roundtables.default',
                params: { courseID },
                query: queryObject,
              };
            }

            return this.$router.push(courseRoute);
          })
            .catch((error) => {
              if (error.response.status === 403) {
                EventBus.$emit('toast-msg', error.response.data.error);
              }
              return;
            });
        }
      },
      createNewCourse() {
        EventBus.$emit('open-new-course-modal');
      },
      openCreateActivityPage() {
        this.show_choose_activity_overlay = true;
      },
      backToDashboard() {
        if (!this.hasTeacherPermissionsInCourse) {
          store.dispatch('analytics', 'student - access the course page',
            { routeFrom: 'dropdown menu' }
          );
        }
        if (this.hasTeacherPermissionsInCourse) {
          store.dispatch('analytics', 'teacher - access the course page',
            { routeFrom: 'dropdown menu' }
          );
        }
        this.$router.push({ name: 'dashboard' });
      },
      // NOTE: This whole thing feels like a big anti pattern
      changeCourseTab(courseTab) {
        // DECLARE ROUTE OBJECT
        let route = { ...this.route_default };
        if (['roundtable.feed', 'roundtable.index', 'course.roundtables.default', 'live-discussion.index'].includes(this.$route.name) && courseTab === 'roundtables') {
          return;
        }
        switch (courseTab) {
          case 'roundtables':
            if (this.last_roundtable_route.name) {
              route = this.last_roundtable_route;
            } else {
              route.name = 'course.roundtables.default';
            }
            break;
          case 'students':
            route.name = 'course.students';
            break;
          case 'settings':
            route.name = 'course.settings.general';
            break;
          case 'dashboard':
            route = { name: 'dashboard' };
            break;
          default:
            route.query = null;
        }
        return this.$router.replace(route);
      },
      fetchRoundtable(roundtableID) {
        const fetchRoundtable = 'fetchRoundtable';
        const myRTIdentity = 'myRTIdentity';
        const needRoundtableFetched = this.getCurrentRT.id !== roundtableID;
        if (needRoundtableFetched) {
          store.dispatch(fetchRoundtable, roundtableID);
          store.dispatch(myRTIdentity, roundtableID);
        }
      },
      viewActivity(activity) {
        return activity.prompt || activity.prompt === ''
          ? this.navigateToRT(activity)
          : this.navigateToLD(activity);
      },
      navigateToRT(roundtable, replace = false) {
        // NOTE: Temporary solution to the student seeing the discussion before submitting
        const teacher = this.hasTeacherPermissionsInCourse;
        teacher ?
          store.dispatch('analytics', 'teacher written roundtable - access written roundtable') :
          store.dispatch('analytics', 'student written roundtable - access written roundtable');
        if (this.$route.params.roundtableID === roundtable.id) {
          return;
        }
        const route = {
          name: 'roundtable.index',
          params: {
            roundtableID: roundtable.id,
            courseID: this.$route.params.courseID,
          },
        };
        if (replace) {
          this.$router.replace(route);
        } else {
          this.$router.push(route);
        }
      },
      navigateToLD(discussion) {
        const teacher = this.hasTeacherPermissionsInCourse;
        teacher ? store.dispatch('analytics', 'teacher verbal roundtable - access verbal roundtable') : store.dispatch('analytics', 'student verbal roundtable - access verbal roundtable');
        this.$router.replace({
          name: 'live-discussion.index',
          params: {
            liveDiscussionID: discussion.id,
            courseID: this.$route.params.courseID,
          },
        });
      },
      autoViewRoundtable() {
        // this function sees if you have the right RT in getCurrentRT. if so, show it.
        // If not, see if you have roundtables in course. If so, take the first one,
        // fetch it and navigate to it
        // const { getCurrentRT } = this;
        // if (this.current_rt_is_already_in_state) {
        //   return this.navigateToRT(getCurrentRT);
        // }
        const firstRoundtableListed = this.getOrderedOnlineRTs[0];
        const firstLiveDiscussionListed = this.getOrderedLiveDiscussions[0];
        if (firstRoundtableListed) {
          this.navigateToRT(firstRoundtableListed, true);
        } else if (firstLiveDiscussionListed) {
          this.navigateToLD(firstLiveDiscussionListed, true);
        }
      },
      loadPage() {
        const { courseID, roundtableID, liveDiscussionID } = this.$route.params;
        const { name } = this.$route;
        this.leaveCourseSocket(this.$route.params.courseID);
        this.setupCourseSocket(this.$route.params.courseID);
        if (name === 'roundtable-feed' || name === 'course.roundtables.default') {
          return store.dispatch('enterCourse', courseID)
            .then((data) => {
              if (!(roundtableID || liveDiscussionID)) {
                this.autoViewRoundtable();
                return data;
              }
            });
        } else {
          store.dispatch('enterCourse', courseID);
        }
      },
      showRTWelcomeModal(activityType) {
        getWelcomeSettings.getSettingsByQuery(activityType)
        .then((data) => {
          let show = [];
          this.welcomeRoundTableData = data;
          show = data.map(e => e.enabled);
          let videos = data.filter(e => e.video_url && e.video_url.length > 0 );
          if (show.includes(true) && videos.length > 0){
            this.show_RT_Welcome_modal = true;
          }
        });
      },
      closeRTWelcomeModal(){
        this.show_RT_Welcome_modal = false;
      }
    },
    beforeRouteUpdate(to, from, next) {
      const { courseID, roundtableID, liveDiscussionID } = to.params;
      if (courseID && courseID !== this.getCourseDetail.id) {
        store.dispatch('enterCourse', courseID)
        .then(() => {
          if (!(roundtableID || liveDiscussionID)) {
            this.autoViewRoundtable();
          }
        });
      }
      if (to.params.courseID !== from.params.courseID) {
        this.setupCourseSocket(to.params.courseID);
        this.leaveCourseSocket(from.params.courseID);
      }
      // cache last route, if you go to another tab ie. settings, students
      const roundtableRouteNames = ['roundtable.feed'];
      const lastRoute = this.last_roundtable_route;
      if (roundtableRouteNames.includes(from.name)) {
        lastRoute.name = from.name;
        lastRoute.params = from.params;
        lastRoute.query = from.query;
      }
      next();
    },
    beforeRouteLeave: function(to, from, next){
      this.leaveCourseSocket(from.params.courseID);
      next();
    },
    async created(){
      if (!this.isProfileLoading) {
        await this.loadPage();
      }
    },
    mounted() {
      EventBus.$on('openCreateActivityPage', this.openCreateActivityPage);

      EventBus.$on('showWelcomeLiveRT', () => {
        this.showRTWelcomeModal('live');
      });
      EventBus.$on('rtIntegrationAssignment', (sync_assessment,integration_name) => {
        this.sync_assessment = sync_assessment;
        this.show_sync_assessment_modal = !sync_assessment;
        this.show_integrations_modal = sync_assessment;
        this.selected_integration = integration_name ? integration_name : 'google-classroom';
        this.edLink = integration_name ? true : false;
        this.logo = integration_name ? `/static/integrations/${integration_name.charAt(0).toUpperCase() +
                integration_name.slice(1)}.png` : '/static/google_class_round.png.png';
      });
      EventBus.$on('selectedIntegrationSync', (sync_assessment, integration_name) => {
        this.sync_assessment = sync_assessment;
        this.show_integrations_modal = false;
        this.show_sync_assessment_modal = true;
        this.selected_integration = integration_name ? integration_name : 'google-classroom';
        this.edLink = integration_name ? true : false;
        this.logo = integration_name ? `/static/integrations/${integration_name.charAt(0).toUpperCase() +
                integration_name.slice(1)}.png` : '/static/google_class_round.png';
      });
    },
    beforeDestroy() {
      EventBus.$off('openCreateActivityPage');
      EventBus.$off('showWelcomeLiveRT');
      EventBus.$off('rtIntegrationAssignment');
      EventBus.$off('selectedIntegrationSync');
      this.leaveCourseSocket(this.$route.params.courseID);
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus'
    .course-side-bar-desktop
      background: pl-white-smoke
</style>



// WEBPACK FOOTER //
// courses.vue?3d53dd84